<template>
  <el-card class="box-card" shadow="never">
    <div slot="header" class="card-header">
      <div class="cheader">
        <span>{{ materialTypeName }}分组</span>
      </div>
      <div>
        <el-input
          v-model="search_grouping_value"
          @input="search_grouping_watch"
          placeholder="分组名称"
        ></el-input>
      </div>

      <!-- <div v-if="!disabled" class="btn-wrap">
        <el-button
          plain
          type="primary"
          icon="el-icon-folder-add"
          @click="handleAddItem"
        >
          新增
        </el-button>
      </div> -->
    </div>
    <!--      default-expand-all     :default-expanded-keys="[0]"     :expand-on-click-node="false"  -->
    <div class="group-list-tree">
      <el-tree
        v-show="GroupsListTreeShow.length == 1"
        :default-expanded-keys="[0]"
        ref="tree"
        :data="GroupsListTreeShow"
        :aa="groupsListTree"
        :props="defaultProps"
        auto-expand-parent
        highlight-current
        node-key="id"
        @node-click="handleNodeClick"
      >
        <!--    :default-expand-all="GroupsListTreeShow.length == 1 ? true : false" -->
        <div slot-scope="{ node, data }" class="custom-tree-node">
          <div
            class="name-wrap"
            @click="showGroupsListTree(node, data, !disabled && data.id)"
          >
            <div class="name" :title="node.label">{{ node.label }}</div>
            {{ `(${data.count})` }}
          </div>
        </div>
      </el-tree>
      <!--   :default-expanded-keys="defaultKey" -->
      <el-tree
        v-show="GroupsListTreeShow.length !== 1"
        :default-expand-all="true"
        ref="tree"
        :data="GroupsListTreeShow"
        :props="defaultProps"
        node-key="id"
        @node-click="handleNodeClick"
      >
        <div slot-scope="{ node, data }" class="custom-tree-node">
          <div
            class="name-wrap"
            @click="showGroupsListTree(node, data, !disabled && data.id)"
          >
            <div class="name" :title="node.label">{{ node.label }}</div>
            {{ `(${data.count})` }}
          </div>
        </div>
      </el-tree>
    </div>
    <div class="group-list-tree-show-edit" v-show="treeShowEdit">
      <div class="btn" @click="add_tree" v-if="level">
        添加子分组
      </div>
      <div class="btn" @click="recompose">
        重命名
      </div>
      <!-- {{  }} -->
      <div class="btn" @click="createLink" v-if="materialType === 0">
        生成链接
      </div>
      <div class="btn" @click="delete_tree">
        删除分组
      </div>
    </div>

    <div class="group-list-tree-show-edit" v-show="treeShowEditAll">
      <div class="btn" @click="add_tree">
        添加子分组
      </div>
    </div>

    <add-material-group-dialog
      ref="addItemDialog"
      :edit-item="curEditItem"
      :material-type="materialType"
      @edited="handleEditedItem"
      :edit-id="get_tree_edit_id"
    />

    <el-dialog title="复制链接" :visible.sync="linkUrlShow" width="30%">
      <span>{{ linkUrl }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkUrlShow = false">取 消</el-button>
        <el-button type="primary" @click="affirm_link_url">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import AddMaterialGroupDialog from './add-material-group-dialog.vue';
import { mapGetters } from 'vuex';
export default {
  components: { AddMaterialGroupDialog },
  props: {
    materialType: {
      type: Number,
      required: true,
    },
    groupsList: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectGroup: {
      type: [Number, String, null],
      default: null,
    },
  },

  data() {
    return {
      defaultExpandAll: false,
      search_grouping_value: '',
      GroupsListTreeShow: [
        {
          id: null,
          type: 'all',
          groupName: '全部',
          count: 0,
        },
      ],
      saveGroupsListTree: [],
      curEditItem: Object.assign({}, CONST.DEF_MATERIAL_GROUP_ITEM),
      treeShowEdit: false,
      treeShowEditAll: true,
      level: false,
      get_tree_edit_id: 0,
      defaultProps: {
        children: 'children',
        label: 'groupName',
      },
      groupName: '',
      total: 0,
      defaultKey: [],
      linkUrl: '',
      linkUrlShow: false,
    };
  },
  computed: {
    ...mapGetters(['sellerBookingType', 'yyStoreId']),
    requestPre() {
      return this.sellerBookingType === 1 ? '/bookingAdmin' : '';
    },
    materialTypeName() {
      return this.materialType === CONST.MATERIAL_TYPE.img ? '图片' : '视频';
    },
    groupsListTree() {
      const total = _.sum(this.groupsList.map(t => t.count));
      this.total = total;
      const other = {
        id: null,
        type: 'all',
        groupName: '全部' + this.materialTypeName,
        count: total,
      };
      this.saveGroupsListTree = [
        {
          ...other,
          children: _.cloneDeep(this.groupsList),
        },
      ];
      this.GroupsListTreeShow = [
        {
          ...other,
          children: _.cloneDeep(this.groupsList),
        },
      ];
      return [];
    },
  },
  watch: {
    groupsList: {
      immediate: true,
      handler: function(val, oldVal) {
        if (val) {
          // 初始化设为全部..没绑定click的数据
          this._setTreeGroupId();
        }
      },
    },
  },
  methods: {
    //
    recompose() {
      this.$prompt('修改名称', '', {
        inputValue: this.groupName,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        inputValidator: e => {
          console.log(e);
        },
      }).then(({ value }) => {
        if (value === this.groupName) {
          return;
        }
        this.$http
          .post(
            `${this.requestPre}/materialGroup/update`,
            {
              id: this.get_tree_edit_id,
              groupName: value,
              type: this.materialType,
            },
            {
              catchBusinessErr: true,
            }
          )
          .then(res => {
            this.$emit('deleteGroup', this.get_node_id);
            this.$message.success('修改成功！');
          });
      });
    },
    // 生成链接并复制
    affirm_link_url() {
      this.linkUrlShow = false;
      let input = document.createElement('input');
      input.setAttribute('value', this.linkUrl);
      document.body.appendChild(input);
      input.setSelectionRange(0, this.linkUrl.length);
      input.select();
      input.id = 'minput';
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success('复制成功！');
      }

      document.body.removeChild(input);
    },
    createLink() {
      this.linkUrl = `http://business.mall.linkiebuy.com/sellerMaterialGroup=${this.get_tree_edit_id}`;
      this.linkUrlShow = true;
      // const data = `http://business.mall.linkiebuy.com/sellerMaterialGroup=${this.get_tree_edit_id}`;
      // let input = document.createElement('input');
      // input.setAttribute('value', data);
      // document.body.appendChild(input);
      // input.setSelectionRange(0, data.length);
      // input.select();
      // input.id = 'minput';

      // this.$alert(data, '复制链接', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //     console.log(action);
      //     // confirm
      //     if (action == 'confirm') {
      //       if (document.execCommand('copy')) {
      //         document.execCommand('copy');
      //         this.$message.success('复制成功！');
      //       }
      //     }

      //     document.body.removeChild(input);
      //   },
      // });

      // this.$confirm(data, '复制链接', {
      //   confirmButtonText: '确定',
      //   center: true,
      // })
      //   .then(() => {
      //     if (document.execCommand('copy')) {
      //       document.execCommand('copy');
      //       this.$message.success('复制成功！');
      //     }
      //     document.body.removeChild(input);
      //   })
      //   .catch(() => {
      //     document.body.removeChild(input);
      //   });

      // this.$alert(data, '复制链接', {
      //   confirmButtonText: '确定',
      //   callback: action => {

      //   },
      // });
    },
    _setTreeGroupId() {
      setTimeout(() => {
        this.$refs.tree &&
          this.$refs.tree.setCurrentNode({
            id: this.selectGroup,
          });
      });
    },

    search_grouping_watch(value) {
      // _.cloneDeep
      const findTree = val => {
        if (val.groupName.indexOf(value) != -1) {
          return true;
        }
        if (val.children !== null) {
          for (let v of val.children) {
            if (v.groupName.indexOf(value) != -1) {
              return true;
            }
            if (v.children !== null) {
              for (let c of v.children) {
                if (c.groupName.indexOf(value) != -1) {
                  return true;
                }
              }
            }
            //return findTree(v);
          }
        } else {
          return false;
        }
      };
      if (value === '') {
        this.GroupsListTreeShow = _.cloneDeep(this.saveGroupsListTree);
        this.defaultExpandAll = false;
      } else {
        let TreeShow = [];
        for (let val of this.saveGroupsListTree[0].children) {
          if (findTree(val)) {
            TreeShow.push(val);
          }
        }
        this.GroupsListTreeShow = TreeShow;
        this.defaultExpandAll = true;

        // console.log(this.defaultExpandAll);
        // console.log(JSON.stringify(TreeShow));
        // this.defaultKey = [];
        // console.log(this.defaultKey);
        // for (let v in TreeShow) {
        //   this.defaultKey.push(Number(v));
        // }
        // console.log(this.defaultKey);
        // this.GroupsListTreeShow[0].children = TreeShow;

        // this.GroupsListTreeShow = [
        //   {
        //     id: null,
        //     type: 'all',
        //     groupName: '全部' + this.materialTypeName,
        //     count: this.count,
        //     children: TreeShow,
        //   },
        // ];
      }
      console.log('_search_grouping_watch');
    },

    add_tree() {
      this.curEditItem = Object.assign({}, CONST.DEF_MATERIAL_GROUP_ITEM);
      this.$refs.addItemDialog.open();
    },
    delete_tree() {
      this.$confirm('仅删除分组,组内的素材将纳入未分组', '提示', {
        type: 'warning',
      }).then(res => {
        this.$http
          .post(
            `${this.requestPre}/materialGroup/delete`,
            {
              id: this.get_tree_edit_id,
            },
            {
              catchBusinessErr: true,
            }
          )
          .then(res => {
            this.$emit('deleteGroup', this.get_node_id);
            this.$message.success('删除成功！');
          });
      });
    },
    showGroupsListTree(node, data, bool) {
      this.treeShowEdit = false;
      this.treeShowEditAll = false;
      if (!bool) {
        if (data.type === 'all') {
          this.get_tree_edit_id = 0;
          this.treeShowEditAll = true;
        }
        return;
      }

      this.groupName = data.groupName;
      this.treeShowEdit = true;
      this.get_tree_edit_id = data.id;
      this.get_node_id = node.id;
      this.level = data.children == null && data.level == 3 ? false : true;

      console.log(JSON.stringify(data));
    },
    handleNodeClick(node, data) {
      this.$emit('selectGroup', node.id);
    },
    handleAddItem() {
      this.curEditItem = Object.assign({}, CONST.DEF_MATERIAL_GROUP_ITEM);
      this.$refs.addItemDialog.open();
    },
    handleEditedItem() {
      this.$emit('addGroup');
    },
    handleDel(node, data) {
      this.$confirm('仅删除分组,组内的素材将纳入未分组', '提示', {
        type: 'warning',
      }).then(res => {
        this.$http
          .post(
            `${this.requestPre}/materialGroup/delete`,
            {
              id: data.id,
            },
            {
              catchBusinessErr: true,
            }
          )
          .then(res => {
            this.$emit('deleteGroup', node.id);
            this.$message.success('删除成功！');
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  height: 100%;
  position: relative;
}

.group-list-tree-show-edit {
  background-color: white;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 50px;
  border-top: 1px solid rgb(223, 223, 223);
  display: flex;
  justify-content: space-around;
  align-items: center;

  .btn {
    height: 35px;
    line-height: 35px;
    // max-width: 70px;
    padding: 0px 5px;
    font-size: 9px;
    border-radius: 5px;
    border: 1px solid rgb(223, 223, 223);
    cursor: pointer;
  }
}
.custom-tree-node {
  display: flex;
  align-content: center;
  align-items: center;
  .name-wrap {
    flex: 1;
    .name {
      display: inline-block;
      max-width: 110px;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
    }
  }
  .btn-wrap {
  }
}

.group-list-tree {
  padding-bottom: 70px;
  max-height: calc(100vh - 470px);
  overflow-y: auto;
  @include scrollBar;
}
.cheader {
  margin-right: 5px;
}
</style>
